import React from 'react';
import { CLOSE_ACTION_MODAL_CHILD, OPEN_ACTION_MODAL_CHILD } from '../redux/actions/componentsActions';
import store from '../redux/store';
import { getCommonRoutePath } from './Helpers';

import { NavLink } from 'react-router-dom';
import { GROUP_CHAT_WATCHED } from '../redux/actions/groupChatsActions';
import { localStorageWrapper } from './storageFactory';

export const openChatBlock = (element, topCoord = 0) => {
    let top = topCoord;
    if (element) {
        try {
            const elemTop = Math.ceil(element.getBoundingClientRect().top);
            if (elemTop > 400) {
                top = elemTop - 200;
            }
        } catch (e) {
            // TODO: handle error?
        }
    }
    store.dispatch({
        type: OPEN_ACTION_MODAL_CHILD,
        payload: {
            children: (
                <div className="general-popup chat-block-popup" id="verification">
                    <div className="sub-title">
                        You are unable to use your ambassador app account on the TAP Feed to speak to other ambassadors.
                        If you would like to start a chat, please create a new account with a different email address.
                    </div>
                    <div className="chat-redirect-block">
                        Click{' '}
                        <NavLink to={getCommonRoutePath() + '/interaction/dialogs'} onClick={handleClosePopup}>
                            here
                        </NavLink>{' '}
                        to see all your active dialogues.
                    </div>
                    <button type="submit" className="el-btn general-action-button cancel" onClick={handleClosePopup}>
                        OK
                    </button>
                </div>
            ),
            styles: {
                top: top,
            },
            positionAbsolute: true,
        },
    });
};

export const handleClosePopup = () => {
    store.dispatch({
        type: CLOSE_ACTION_MODAL_CHILD,
    });
};

export const watchChat = (dialogId, universityId, track = true) => {
    dialogId = +dialogId;
    let chatsWatched = [];
    let currentChatWatch = false;
    if (localStorageWrapper.getItem('chatsWatched')) {
        chatsWatched = JSON.parse(localStorageWrapper.getItem('chatsWatched'));
        if (!chatsWatched.includes(dialogId)) {
            chatsWatched.push(dialogId);
            currentChatWatch = true;
        }
    } else {
        chatsWatched.push(dialogId);
        currentChatWatch = true;
    }

    if (currentChatWatch) {
        store.dispatch({
            type: GROUP_CHAT_WATCHED,
            payload: {
                dialog_id: dialogId,
            },
        });
        localStorageWrapper.setItem('chatsWatched', JSON.stringify(chatsWatched));
    }
};

export const checkIfChatAnswered = (messages) => {
    const account = store.getState().account;
    if (account.account_info && account.account_info.key === 'prospect') {
        return messages.items.find(
            (message, index) => index > 1 && message.user && message.user.id !== account.account_info.id
        );
    } else {
        return false;
    }
};

export const getQueryDataOnSignClick = () => {
    const { utmData } = store.getState().widget;
    const { authCode, token } = store.getState().account;

    let queryData = (authCode ? '?auth=' + authCode + '&' : '?') + 'signUp=true';
    if (utmData.utmMedium) {
        queryData +=
            '&utm_medium=' +
            utmData.utmMedium +
            '&utm_source=' +
            utmData.utmSource +
            '&utm_campaign=' +
            utmData.utmCampaign +
            (utmData.cameFrom ? '&cameFrom=' + utmData.cameFrom : '');
    }
    if (token) {
        queryData += '&signed_in_token=' + token;
    }
    return queryData;
};
